import serviceContractApi from '@/api/purchaseSalesCenter/outerServiceContract.js';
import XEUtils from 'xe-utils/methods/xe-utils';
export default {
  methods: {
    // 按钮点击
    chooseClick(type) {
      this[type]();
    },
    //新增 触发事件
    create() {
      let path = {
        path: 'salePurchase/serviceContractDetail',
        name: 'serviceContractDetail',
        meta: {
          keepAlive: false,
          title: '服务合同维护',
        },
        query: {
          status: 'create',
        },
      };
      this.$router.push(path);
    },
    // 选择一行判断
    checkSelectOneData() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择一行操作');
        return false;
      }
      if (this.multipleSelection.length != 1) {
        this.$message.error('只能选择一行操作');
        return false;
      }
      return true;
    },
    // 导出 处理函数
    async exportHandler() {
      const idList = this.multipleSelection.map((item) => item.id);
      let data;
      if (!idList.length && !this.tableData) {
        this.$message.error('没有数据可以导出！');
        return;
      }
      const tableList = this.tableData.map((item) => item.id);
      if (!idList.length) {
        this.loading = true;
        data = await this.$axios.post(serviceContractApi.EXPORT_CONTRACT, { idList: tableList });
        this.loading = false;
      }
      this.loading = true;
      data = await this.$axios.post(serviceContractApi.EXPORT_CONTRACT, { idList: idList });
      this.loading = false;
      if (data.data.code === 0) {
        window.location.href = data.data.data;
        this.$message.success('导出成功');
      } else {
        this.$message.error('导出失败');
      }
    },
    // 复制按钮
    copy() {
      console.log('点击了复制按钮');
      if (this.checkSelectOneData()) {
        if (this.multipleSelection[0].contractStatus == 'ZT03') {
          const path = {
            path: 'salePurchase/serviceContractDetail',
            name: 'serviceContractDetail',
            meta: {
              keepAlive: false,
              title: '',
            },
            query: {
              id: this.multipleSelection[0].id,
              status: 'create',
              isCopy: true,
            },
          };
          this.$router.push(path);
        } else {
          this.$message.error('只能复制已生效的合同!');
        }
      }
    },
    // 删除按钮
    delete() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择要删除的行!');
        return;
      }
      this.deleteIds = this.multipleSelection.map((item) => item.id);
      const isDelete = this.multipleSelection.every((item) =>
        ['ZT00'].includes(item.contractStatus)
      );
      if (!isDelete) {
        this.deleteIds = [];
        this.$message.error('只有已保存的合同才可以删除!');
        return;
      }
      console.log(this.deleteIds, '删除的ids');
      this.$refs.deleteContractRef.openDialog();
    },
    // 提交审批按钮
    async approve() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择要提交审批的数据!');
        return;
      }
      const ids = this.multipleSelection.map((item) => item.id);
      const isSubmit = this.multipleSelection.every((item) =>
        ['ZT00', 'ZT05', 'ZT061', 'ZT051'].includes(item.contractStatus)
      );
      if (!isSubmit) {
        this.$message.error('只有已保存、已驳回、修订中、修订已驳回的合同才可以提交审批!');
        return;
      }
      this.loading = true;

      const {
        data: { code, msg },
      } = await this.$axios.post(serviceContractApi.SAVE_OR_SUBMIT, {
        ids,
        operateFlag: '4',
        oaId: this.userInfo.oaId,
        createBy: this.userInfo.userName,
        departmentCode: this.departmentCode,
        departmentName: this.userInfo.departmentName,
        gmtCreate: XEUtils.toDateString(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      });
      this.loading = false;
      if (code === 0) {
        this.$message.success(msg);
        this.resetBtnClick();
      } else {
        this.$message.error(msg);
      }
    },
    // 删除申请
    deleteApproval() {
      if (!this.multipleSelection.length) {
        this.$message.error('请选择要删除的行');
        return;
      }
      if (this.checkSelectOneData()) {
        this.deleteIds = this.multipleSelection.map((item) => item.id);
        const isDelete = this.multipleSelection.every((item) =>
          ['ZT03'].includes(item.contractStatus)
        );
        if (!isDelete) {
          this.deleteIds = [];
          this.$message.error('只有已生效的合同才可以发起删除申请!');
          return;
        }
        console.log(this.deleteIds, '删除的ids');
        this.$refs.deleteApprovalRef.openDialog();
        this.resetBtnClick();
      }
    },
  },
};
